export enum BetCalculationType {
  DEFAULT,
  AVERAGE,
  FREESPINS,
}

export class InternalBet {
  get isExtraBet(): boolean {
    return this.effectiveBet > 0;
  }
  effectiveBet = -1.0;
  bet: number;
  isXtremeBet = false;
  calculationType: BetCalculationType;
}
